var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWireLines({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 284,
    viewBox: "0 0 240 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.941 364V196.232C146.941 186.364 138.941 178.364 129.073 178.364H30.3086C21.0575 178.364 13.558 170.865 13.558 161.614V-11.9152C13.558 -21.7831 5.55853 -29.7825 -4.30931 -29.7825L-63 -29.7824",
    stroke: "url(#paint0_linear_537_6495)",
    strokeWidth: 0.558353
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.865 61.5082L62.9085 61.5081C72.1596 61.5081 79.6591 69.0076 79.6591 78.2587V229.175C79.6591 238.426 87.1586 245.925 96.4097 245.925H347.948",
    stroke: "url(#paint1_linear_537_6495)",
    strokeWidth: 0.558353
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 -67H85.0023V33.5035C85.0023 42.7546 92.5018 50.2541 101.753 50.2541H219.007V166.95H352.732",
    stroke: "url(#paint2_linear_537_6495)",
    strokeWidth: 0.558353
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_537_6495",
    x1: 121.325,
    y1: 341.951,
    x2: 112.469,
    y2: -6.92034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421791,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_537_6495",
    x1: 129.503,
    y1: 304.58,
    x2: 158.362,
    y2: 64.9239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421791,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_537_6495",
    x1: 87.2528,
    y1: -67,
    x2: 296.287,
    y2: 174.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514057,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWireLines);
export default __webpack_public_path__ + "static/media/wire-lines.b8706ecdccf35a061431856418ed7819.svg";
export { ForwardRef as ReactComponent };